export default class TypeDevice {
	id: number;		//ид
	type: string;	//тип оборудования
}